import { render, staticRenderFns } from "./LayersCopyIcon.vue?vue&type=template&id=1bc8203f&scoped=true"
import script from "./LayersCopyIcon.vue?vue&type=script&lang=js"
export * from "./LayersCopyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8203f",
  null
  
)

export default component.exports